"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractListQueryRequest = void 0;
var ContractListQueryRequest = /** @class */ (function () {
    function ContractListQueryRequest() {
    }
    return ContractListQueryRequest;
}());
exports.ContractListQueryRequest = ContractListQueryRequest;
;
//# sourceMappingURL=contractListQuery.request.js.map